import { render, staticRenderFns } from "./ProgrammeEditModal.vue?vue&type=template&id=f8203a96&"
import script from "./ProgrammeEditModal.vue?vue&type=script&lang=js&"
export * from "./ProgrammeEditModal.vue?vue&type=script&lang=js&"
import style0 from "./ProgrammeEditModal.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports